import { useSelector } from "react-redux";

export function useDOMAttachToSystemStore() {
    const latest_event_fired = useSelector((state) => state.entities.system.DOMAttachToSystem.latest_event_fired);
    const latest_event_fired_uuid = useSelector((state) => state.entities.system.DOMAttachToSystem.latest_event_fired_uuid)
    const eventFired = useSelector((state) => state.entities.system.DOMAttachToSystem.event)
    const latest_system_notification_data = useSelector((state) => state.entities.system.DOMAttachToSystem.latest_system_notification_data);
    const latest_system_notification_UUID = useSelector((state) => state.entities.system.DOMAttachToSystem.latest_system_notification_UUID);
    const latest_system_notification_name = useSelector((state) => state.entities.system.DOMAttachToSystem.latest_system_notification_name);
    const system_notification = useSelector((state) => state.entities.system.DOMAttachToSystem.system_notification);
    const QuotePopup = useSelector((state) => state.entities.system.DOMAttachToSystem.system_notification.QuotePopup);
    const SendEmailOfCurrentPage = useSelector((state) => state.entities.system.DOMAttachToSystem.system_notification.SendEmailOfCurrentPage);
    const AddedToCartNotification = useSelector((state) => state.entities.system.DOMAttachToSystem.system_notification.AddedToCartNotification);
    const SendEmailOfReportError = useSelector((state) => state.entities.system.DOMAttachToSystem.system_notification.SendEmailOfReportError);
    const AddedToBomPopup = useSelector((state) => state.entities.system.DOMAttachToSystem.system_notification.AddedToBomPopup);
    const AddedToCartBomPopup = useSelector((state) => state.entities.system.DOMAttachToSystem.system_notification.AddedToCartBomPopup);
    const AddedToQuoteBomPopup = useSelector((state) => state.entities.system.DOMAttachToSystem.system_notification.AddedToQuoteBomPopup);
    const AlternativeBomPopup = useSelector((state) => state.entities.system.DOMAttachToSystem.system_notification.AlternativeBomPopup);
    const BomDeletePopup = useSelector((state) => state.entities.system.DOMAttachToSystem.system_notification.BomDeletePopup);
    const BomDeleteProjectPopup = useSelector((state) => state.entities.system.DOMAttachToSystem.system_notification.BomDeleteProjectPopup);
    const BomEditColumnsPopup = useSelector((state) => state.entities.system.DOMAttachToSystem.system_notification.BomEditColumnsPopup);
    const BomSearchMatchPopup = useSelector((state) => state.entities.system.DOMAttachToSystem.system_notification.BomSearchMatchPopup);
    const CreatePartPopup = useSelector((state) => state.entities.system.DOMAttachToSystem.system_notification.CreatePartPopup);
    const DownloadBomPopup = useSelector((state) => state.entities.system.DOMAttachToSystem.system_notification.DownloadBomPopup);
    const FindPartPopup = useSelector((state) => state.entities.system.DOMAttachToSystem.system_notification.FindPartPopup);
    const AddToBOMPopup = useSelector((state) => state.entities.system.DOMAttachToSystem.system_notification.AddToBOMPopup);
    const ClearCartPopup = useSelector((state) => state.entities.system.DOMAttachToSystem.system_notification.ClearCartPopup);
    const InventoryAlertForAddToCartPopup = useSelector((state) => state.entities.system.DOMAttachToSystem.system_notification.InventoryAlertForAddToCartPopup);
    const InventoryAlertPopup = useSelector((state) => state.entities.system.DOMAttachToSystem.system_notification.InventoryAlertPopup);
    const ShareCartPopup = useSelector((state) => state.entities.system.DOMAttachToSystem.system_notification.ShareCartPopup);
    const ShippingAddressPopup = useSelector((state) => state.entities.system.DOMAttachToSystem.system_notification.ShippingAddressPopup);
    const AddShippingAddressPopup = useSelector((state) => state.entities.system.DOMAttachToSystem.system_notification.AddShippingAddressPopup);
    const ChangeShippingAddressPopup = useSelector((state) => state.entities.system.DOMAttachToSystem.system_notification.ChangeShippingAddressPopup);
    const AddedPartQuotePopup = useSelector((state) => state.entities.system.DOMAttachToSystem.system_notification.AddedPartQuotePopup);
    const ClearQuotePopup = useSelector((state) => state.entities.system.DOMAttachToSystem.system_notification.ClearQuotePopup);
    const DeleteQuotePopup = useSelector((state) => state.entities.system.DOMAttachToSystem.system_notification.DeleteQuotePopup);
    const QuoteAdvanceFilterPopup = useSelector((state) => state.entities.system.DOMAttachToSystem.system_notification.QuoteAdvanceFilterPopup);
    const QuoteDetailFilterPopup = useSelector((state) => state.entities.system.DOMAttachToSystem.system_notification.QuoteDetailFilterPopup);
    const QuoteFilterPopup = useSelector((state) => state.entities.system.DOMAttachToSystem.system_notification.QuoteFilterPopup);
    const QuoteMessagePopup = useSelector((state) => state.entities.system.DOMAttachToSystem.system_notification.QuoteMessagePopup);
    const SubmitQuotePopup = useSelector((state) => state.entities.system.DOMAttachToSystem.system_notification.SubmitQuotePopup);
    const BomCreateProjectPopup = useSelector((state) => state.entities.system.DOMAttachToSystem.system_notification.BomCreateProjectPopup);

    let data = {
        latest_event_fired,
        latest_event_fired_uuid,
        eventFired,
        latest_system_notification_data,
        latest_system_notification_UUID,
        latest_system_notification_name,
        system_notification,
        QuotePopup,
        SendEmailOfCurrentPage,
        AddedToCartNotification,
        SendEmailOfReportError,
        AddedToBomPopup,
        AddedToCartBomPopup,
        AddedToQuoteBomPopup,
        AlternativeBomPopup,
        BomDeletePopup,
        BomDeleteProjectPopup,
        BomEditColumnsPopup,
        BomSearchMatchPopup,
        CreatePartPopup,
        DownloadBomPopup,
        FindPartPopup,
        AddToBOMPopup,
        ClearCartPopup,
        InventoryAlertForAddToCartPopup,
        InventoryAlertPopup,
        ShareCartPopup,
        ShippingAddressPopup,
        AddShippingAddressPopup,
        ChangeShippingAddressPopup,
        AddedPartQuotePopup,
        ClearQuotePopup,
        DeleteQuotePopup,
        QuoteAdvanceFilterPopup,
        QuoteDetailFilterPopup,
        QuoteFilterPopup,
        QuoteMessagePopup,
        SubmitQuotePopup,
        BomCreateProjectPopup
    };
    let fetch = {
      
    };
    let set = {};

    return [data, fetch, set]
}